export default class PageTtl {
    constructor() {
        this.emArr = [];
        this.iterations = 2;

        this.keyframes = {
            show: { opacity: 1, scale: 1 },
            keepBlack: [
                { color: 'rgb(0, 0, 0)' },
                { color: 'rgb(0, 0, 0)' }
            ],
            keepWhite: [
                { color: 'rgb(255, 255, 255)' },
                { color: 'rgb(255, 255, 255)' }
            ],
            changeBlack: [
                { color: 'rgb(255, 255, 255)', scale: 0.5 },
                { color: 'rgb(0, 0, 0)', scale: 1 },
            ],
            changeWhite: [
                { color: 'rgb(0, 0, 0)', scale: 0.5 },
                { color: 'rgb(255, 255, 255)', scale: 1 },
            ],
        };

        this._init();
    }

    _init() {
        this._getEl();
    }

    _getEl() {
        this.$pageTtlArr = [...document.querySelectorAll('.js-page-ttl')];

        this.$pageTtlArr.forEach($pageTtl => this._wrapTag($pageTtl));
    }

    _wrapTag($pageTtl) {
        const em = [...$pageTtl.innerHTML].findIndex(char => char == '<'),
            newTxt = [...$pageTtl.textContent].map(char => `<span>${char}</span>`).join('');

        this.emArr.push(em);

        $pageTtl.innerHTML = newTxt;
    }

    execLoop(entry) {
        const $tagArr = [...entry.target.querySelectorAll('span')],
            i = this.$pageTtlArr.findIndex($pageTtl => $pageTtl == entry.target);

        $tagArr.forEach(($tag, j) => this._setAnimate($tag, i, j));
    }

    _setAnimate($tag, i, j) {
        const options = {
            delay: 300 + j * 40,
            duration: 400,
            easing: CONFIG.EASING.easeOutCubic,
            fill: 'forwards',
        };

        const animateShow = $tag.animate(this.keyframes.show, options),
            animateTag = $tag.animate(this._getTagKeyframes(), options);

        let count = 0;

        animateTag.onfinish = () => {
            if (count > this.iterations) return;

            animateTag.effect.setKeyframes(this._getTagKeyframes(count, animateTag, i, j));
            animateTag.effect.updateTiming({ delay: null });
            animateTag.play();

            count++;
        };
    }

    _getTagKeyframes(count, animateTag, i, j) {
        const prev = animateTag ? animateTag.effect.getKeyframes() : this.keyframes.keepBlack,
            isBlack = prev.at(-1).color == 'rgb(0, 0, 0)';

        const white = isBlack ? this.keyframes.changeWhite : this.keyframes.keepWhite,
            black = isBlack ? this.keyframes.keepBlack : this.keyframes.changeBlack,
            last = this.emArr[i] == j ? white : black;

        const change = isBlack ? this.keyframes.changeWhite : this.keyframes.changeBlack,
            keep = isBlack ? this.keyframes.keepBlack : this.keyframes.keepWhite,
            state = [change, keep][UTILS.getRandom(0, 1)];

        return count == this.iterations ? last : state;
    }
}
